import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchOrderLog } from "../../services/services";

// Thunk to fetch order logs
export const fetchOrderLogs = createAsyncThunk(
  "orderLogs/fetchOrderLogs",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await fetchOrderLog(orderId);
      return response; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const orderLogSlice = createSlice({
  name: "orderLog",
  initialState: {
    logs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload || [];
      })
      .addCase(fetchOrderLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default orderLogSlice.reducer;
